import { Box, Tab, Tabs } from '@vapor/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ChargeCategoryFragment, useChargeCategoriesQuery } from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'

type PosChargeCategorySelectorProps = {
  propertyId: string
  loading: boolean
  onChargeCategorySelected: (chargeCategory: ChargeCategoryFragment | undefined) => void
}

export default function PosChargeCategorySelector(props: PosChargeCategorySelectorProps) {
  const { propertyId, loading, onChargeCategorySelected } = props
  const { t } = useTranslation()
  const { id: tenantId } = useTenant()
  const [value, setValue] = useState<number>(0)

  const [baseChargeCategories, setBaseChargeCategories] = useState<ChargeCategoryFragment[]>([])
  const { loading: loadingChargeCategories } = useChargeCategoriesQuery({
    variables: {
      filter: {
        tenantId: {
          eq: tenantId,
        },
        propertyId: {
          eq: propertyId,
        },
      },
    },
    onCompleted: (data) => {
      if (data.chargeCategories) {
        setBaseChargeCategories(data.chargeCategories.filter((cc) => !cc.stayIncluded) ?? [])
      }
    },
  })

  useEffect(() => {
    const chargeCategoryIndex = value - 1
    if (chargeCategoryIndex < 0) {
      onChargeCategorySelected(undefined)
    } else if (baseChargeCategories.length > 0) {
      onChargeCategorySelected(baseChargeCategories[chargeCategoryIndex])
    }
  }, [value, baseChargeCategories])

  return (
    <Box mt={'8px'}>
      <Tabs
        {...{ size: 'small' }}
        value={value ?? 'default'}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          '& .MuiTabs-scroller': {
            width: 100,
          },
        }}
        onChange={(event, newValue) => setValue(newValue)}
      >
        <Tab disabled={loadingChargeCategories || loading} label={t('pms.booking.passerby-bill.charge_categories.all')} key={'default'} />
        {baseChargeCategories?.map((cc) => {
          return <Tab disabled={loadingChargeCategories} label={`${cc.name} (${t('pms.booking.passerby-bill.charge_categories.vat')}: ${cc.defaultVat.code})`} key={cc.id} />
        })}
      </Tabs>
    </Box>
  )
}
